var map = {
	"./OscarD1.png": 27391,
	"./OscarD1Launched.png": 54025,
	"./OscarD2.png": 90532,
	"./OscarD2Launched.png": 74150,
	"./OscarD3.png": 44429,
	"./OscarD4.png": 39570,
	"./OscarD5.png": 54395,
	"./OscarW1.png": 6670,
	"./OscarW1Launched.png": 82080,
	"./OscarW2.png": 34501,
	"./OscarW3.png": 98588,
	"./OscarW4.png": 95987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53307;